import React, { useState } from "react";
import firebase from "firebase";
import Loading from "../../Loading";

// okay so after the fetch we return a url and then we need to redirect to that url. what else should we consider?

const isProd = process.env.NODE_ENV === "production";
const logOutput = isProd || true; // always log in production, set true/false to log in local

const createCheckoutSessionFunctionURL = isProd
	? "https://us-central1-aadojo-8bbac.cloudfunctions.net/createcheckoutsession"
	: "http://127.0.0.1:5001/test-preflopmastery/us-central1/createcheckoutsession";

export default function Subscribe() {
	const [loading, setLoading] = useState(false);

	const createCheckoutSession = async (plan = "basic") => {
		if (logOutput) console.log("createCheckoutSession clicked");
		setLoading(true);
		try {
			const result = await fetch(createCheckoutSessionFunctionURL, {
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
				},
				method: "POST",
				body: JSON.stringify({ user: firebase.auth().currentUser, plan }),
			});
			if (logOutput) console.log("createCheckoutSession result", result);
			const data = await result.json();
			if (logOutput) console.log("createCheckoutSession data", data);
			// check that all is good and well
			if (data.url) window.location.href = data.url;
			else console.error("No URL found");
		} catch (error) {
			console.error(error);
		}
	};

	if (loading) return <Loading />;
	return (
		<div className="plans-container">
			<div className="plan-card" onClick={() => createCheckoutSession("basic")} style={{ cursor: "pointer" }}>
				<h2>Basic Plan</h2>
				<p>For players looking to master No Limit Hold'em preflop strategy.</p>
				<span>
					<h3>19.99</h3>
					<span className="price-label">USD/month</span>
				</span>
				<ul>
					<li>
						<h4>Access to NLHE Trees</h4>
						<p>View range displays and charts for hundres of preflop scenarios.</p>
					</li>
					<li>
						<h4>Range Practice Mode:</h4>
						<p>Improve your skills by practicing with real-time feedback.</p>
					</li>
					<li>
						<h4>Data Tracking:</h4>
						<p>Track and analyze your accuracy and progress to identify areas for improvement.</p>
					</li>
				</ul>
				<button className="subscribe-button" onClick={() => createCheckoutSession("basic")}>
					Subscribe
				</button>
			</div>
			<div className="plan-card" onClick={() => createCheckoutSession("plo")} style={{ cursor: "pointer" }}>
				<h2>PLO Plan</h2>
				<p>Expand your training with PLO content for total preflop mastery.</p>
				<span>
					<h3>29.99</h3>
					<span className="price-label">USD/month</span>
				</span>
				<ul>
					<li>
						<h4>All features of the Basic Plan:</h4>
						<p>Get everything from the Basic Plan, plus...</p>
					</li>
					<li>
						<h4>GTO PLO Training:</h4>
						<p>Access to exclusive GTO ranges for Pot-Limit Omaha preflop scenarios.</p>
					</li>
				</ul>
				<button className="subscribe-button" onClick={() => createCheckoutSession("plo")}>
					Subscribe
				</button>
			</div>
			{/* <button onClick={checksubscription}>Check Subscription</button> */}
		</div>
	);
}
